import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    tileBox: {
        display: "flex",
        flexWrap: "wrap",
        padding: theme.spacing(3, 0),
        gap: theme.spacing(2),
        marginBottom: theme.spacing(6),
    },
    tileContainer: {
        backgroundColor: theme.palette.emteria.background.tableHeaders,
        border: "1px solid " + theme.palette.emteria.border.primary,
        display: "inline-flex",
        position: "relative",
        width: "100%",
        height: 88,
        borderRadius: 4,
    },
    tileLabel: { textOverflow: "ellipsis", overflow: "hidden", fontWeight: "normal", fontSize: 16 },
    tileContent: {
        display: "flex",
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        whiteSpace: "nowrap",
        padding: theme.spacing(3, 0),
    },
    limitIconContainer: {
        display: "flex",
        justifyContent: "center",
    },
    cancelBtnBox: {
        display: "flex",
        justifyContent: "flex-end",
        gap: theme.spacing(2),
    },
}));
